import React from 'react';
import { bem, getDataAttr } from '../_libs/utils';
import { Component, PropTypes } from '../_libs';
import CardTitle from './CardTitle';
import CardContent from './CardContent';
import './style/index.scss';
export default class Card extends Component {

  render() {
    const displayName = 'card';
    const { type, children } = this.props;

    return (
      <div
        className={this.className(bem(displayName), type ? `is-${type}` : null)}
        style={this.style()}
        {...getDataAttr(this.props)}>
        <div className={this.classNames(bem(displayName, 'wrapper'))}>
          {children}
        </div>
      </div>
    );
  }
}

Card.defaultProps = {
  children: '',
  type: null,
};

Card.propTypes = {
  // @INTRO 设置卡片内容
  children: PropTypes.node,
  // @INTRO 卡片类型，目前仅有白底的white类型，可以自定义其他类型
  type: PropTypes.string,
};

Card.Title = CardTitle;
Card.Content = CardContent;
